import { GraphQL, useRpiGraphqlRequest } from "@rpi/openapi-api";
import { filterByMatchingAttributes } from "../../hooks/useStandardProducts";
import { ATTRIBUTES } from "./attributeHelpers";
import { ChoiceStep } from "./ChoiceStep";
import { attributesForFiltering, StepProps } from "./ProductCreateNavigator";
import { defaultProductImageConfig, ProductImage } from "./ProductImage";
import { defaultGetTextCardConfig, TextCard } from "./TextCard";
import { useState } from "react";

export function PaperTypeStep(props: StepProps) {
  const filteredProducts = filterByMatchingAttributes(props.standardProducts, attributesForFiltering(props.state));
  const openapiProductId = filteredProducts.length === 1 ? filteredProducts[0].id : undefined;
  const [isCustomerProductCheckLoading, setIsCustomerProductCheckLoading] = useState(false);

  const request = useRpiGraphqlRequest<GraphQL.CustomerProductsQuery, GraphQL.CustomerProductsQueryVariables>(
    GraphQL.CustomerProductsDocument
  );
  const validateOpenapiSkuUnused = async () => {
    if (!openapiProductId) {
      return;
    }

    try {
      setIsCustomerProductCheckLoading(true);
      // Check that the customer hasn't already used this openapi product before advancing to the final step
      // This provides a nicer UX than the error they would get on trying to save the product
      const data = await request({
        limit: 1,
        offset: 0,
        search: {
          inputs: [
            {
              field: GraphQL.CustomerProductSearchField.OpenapiProductId,
              condition: GraphQL.SearchCondition.Equals,
              firstValue: openapiProductId?.toString(),
            },
          ],
        },
      });
      if (data.customerProducts.data.length > 0) {
        return (
          <>
            You already have a product with this exact combination of Cover, Finish, Orientation, Size, Bind, and Paper.
            <br />
            <br />
            Please go back to the previous steps to change one of these selections.
          </>
        );
      }
    } finally {
      setIsCustomerProductCheckLoading(false);
    }
  };

  return (
    <ChoiceStep
      {...props}
      renderCard={(value: string) => {
        const config = defaultGetTextCardConfig(ATTRIBUTES.TEXT_STOCK)(value);
        return config ? <TextCard key={value} {...config} /> : null;
      }}
      renderImage={(value: string) => {
        const config = defaultProductImageConfig(ATTRIBUTES.TEXT_STOCK)(value);
        return config ? <ProductImage {...config} /> : null;
      }}
      flexDirection="column"
      onAdditionalValidation={validateOpenapiSkuUnused}
      isLoading={isCustomerProductCheckLoading}
    />
  );
}
